import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import queryString from 'query-string';
import ScoringGridContainer from './ScoringGridContainer';
import GridAggregateSelector from '../../../../components/GridAggregateSelector';
import BobActionMenu from '../../../../components/BobActionMenu';
import InactiveScoringGridContainer from './InactiveScoringGridContainer';
import SelectEquipmentTypeModal from '../../Modals/SelectEquipmentTypeModal';
import TotalsPanel from '../../../../components/TotalsPanel';
import SiteScoreSelector from '../../../../components/SiteScoreSelector';
import SiteEntitySelector from '../../../../components/SiteEntitySelector';
import GraphViewSelector from '../../../../components/GraphViewSelector';
import BobWorkbookModeButton from '../../../../components/BobWorkbookModeButton';
import ExportDataModal from '../../Modals/ExportDataModal';

import TabViewSelector from '../../../../components/TabViewSelector';

import { getActiveViewName } from '../../Navigation/NavigationHelper';

import * as ArchitectActions from '../../../../actions/architectActions';
import * as BobActions from '../../../../actions/bobActions';
import * as DashboardActions from '../../../../actions/dashboardActions';

import * as classes from './ScoringPage.module.css';

const ScoringPage = ({
    activeTab,
    activeNavCompany,
    activeNavSite,
    allSensors,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    equipmentTypes,
    history,
    handleSubscribeToArea,
    healthscoreRawData,
    healthscoreRawDataMeta,
    fetchScoringData,
    fetchSystemsBySiteId,
    ruleScoreKpis,
    selectedEquipmentType,
    selectedRuleSensors,
    selectedWeatherSensors,
    setRuleScoreKpis,
    setScoreSensorData,
    setWorkBookMode,
    siteTabIndex,
    workbookModeEnabled,
    ...props
}) => {
    const [rules, setRules] = useState([]);
    const [selectEquipmentTypeModalOpen, setSelectEquipmentTypeModalOpen] = useState(true);
    const [selectedEquipmentTypes, setSelectedEquipmentTypes] = useState([]);
    const [selectedEquipment, setSelectedEquipment] = useState({});
    const [selectedEquipmentRule, setSelectedEquipmentRule] = useState({});
    const [selectedSystems, setSelectedSystems] = useState([]);
    const [view, setView] = useState('');
    const [systems, setSystems] = useState([]);
    const propsFunc = {};
    const [refresh, doRefresh] = useState(0);
    const [refreshRawDataGrid, setRefreshRawDataGrid] = useState(false);
    const [chartType, setChartType] = useState('Rules');
    const [systemsLoading, setSystemsLoading] = useState(true);
    const [aggregateType, setAggregateType] = useState('None');
    const [exportRawData, setExportRawData] = useState(false);
    const [exportModalOpen, setExportModalOpen] = useState(false);

    useEffect(() => {
        const queryValues = queryString.parse(history.location.search);

        let viewChildId = queryValues.viewChildId;

        let activeView = getActiveViewName(viewChildId);

        setView(activeView);
    }, [history.location.search]);

    useEffect(() => {
        const init = async () => {
            const payload = await fetchSystemsBySiteId(activeNavSite.id);
            setRuleScoreKpis([]);
            setSystems(payload);
            setSystemsLoading(false);
        };
        if (activeNavSite.id) init();
    }, [activeNavSite.id]);

    useEffect(() => {
        if (selectedEquipmentType) setSelectEquipmentTypeModalOpen(false);
    }, [selectedEquipmentType]);

    useEffect(() => {
        const init = async () => {
            let weatherSensors = '';
            if (!isEmpty(selectedWeatherSensors)) {
                weatherSensors = activeNavSite.address.postalCode + ':' + selectedWeatherSensors.join(':');
            }
            await fetchScoringData(activeNavCompany.id, selectedRuleSensors, [selectedEquipmentRule.ruleId], dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: selectedEquipment.id, weatherSensors });
        };

        if (activeNavSite.id && selectedEquipmentRule.ruleId) init();
    }, [dashboardEndTimeStamp, dashboardStartTimeStamp, desiredInterval]);

    useEffect(() => {
        return () =>
        {
            setScoreSensorData({data: [], meta: {}} );
        };
    }, []);

    const setChartTypeProps = (chart) => {
        setChartType(chart);
    };

    const toggleSelectEquipmentTypeModalOpen = toggle => {
        setSelectEquipmentTypeModalOpen(toggle);
    };

    const handleChangetabView = (tabView) => {
        const queryValues = queryString.parse(history.location.search);

        const { pathname } = history.location;

        if (tabView.viewParentId) {
            queryValues.viewChildId = tabView.key;
            queryValues.childId = tabView.viewParentId;
        } else {
            queryValues.childId = tabView.key;
        }

        const queryValueString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValueString}`);
    };

    const handleImageDownload = ()=>{
        if ( propsFunc && propsFunc.downloadChart) {
            propsFunc.downloadChart();
        }
    };

    const handleExport = event => {
        setExportModalOpen(true); 
    };

    const handleExportGrid = event => {
        if (view === 'rawdata') {
            setExportRawData(true);
        }
        else {
            doRefresh(prev => prev + 1);
        }
    };

    const refreshGrid = () => {
        const init = async () => {
            if (view === 'rawdata') {
                setRefreshRawDataGrid(true);
            }
            else {
                let weatherSensors = '';
                if (!isEmpty(selectedWeatherSensors)) {
                    weatherSensors = activeNavSite.address.postalCode + ':' + selectedWeatherSensors.join(':');
                }


                if (!isEmpty(selectedEquipmentRule)) {
                    await fetchScoringData(activeNavCompany.id, selectedRuleSensors, [selectedEquipmentRule.ruleId], dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { EquipmentId: selectedEquipment.id, weatherSensors });
                } else if (isEmpty(selectedEquipmentTypes) || isEmpty(selectedSystems)) {
                    setSelectEquipmentTypeModalOpen(true);
                }
            }
        };

        if (activeNavSite.id) init();
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    return (
        <div>
            <div className={classes.HeaderContainer}>
                <div className={classes.ViewSelectorContainer}>
                    <TabViewSelector
                        overviewPage={'site'}
                        activeView={view}
                        activeTab={activeTab}
                        handleChangeView={handleChangetabView}
                    />
                </div>
                <div className={classes.AggregateContainer}>
                    <div className={classes.AggregateDivContainer}>
                        { view !== 'rawdata' ? 
                            <React.Fragment>
                                <div className={classes.AggregateDivLabel}>Aggregate Type: </div>
                                <div>
                                    <GridAggregateSelector
                                        aggregateType={aggregateType}
                                        setAggregateType={setAggregateType}
                                    />
                                </div>
                            </React.Fragment>
                            : <div />}
                    </div>
                </div>
                <div className={classes.WorkbookContainer}>
                    <BobWorkbookModeButton
                        handleWorkbookMode={handleWorkbookMode}
                        workbookMode={workbookModeEnabled}
                    />
                </div>
                <div className={classes.TypeSelect}>
                    <SiteEntitySelector
                        equipmentTypes={equipmentTypes.data}
                        setRules={setRules}
                        selectedEquipment={selectedEquipment}
                        selectedEquipmentTypes={selectedEquipmentTypes}
                        selectedSystems={selectedSystems}
                        setSelectedEquipment={setSelectedEquipment}
                        setSelectedEquipmentTypes={setSelectedEquipmentTypes}
                        setSelectedSystems={setSelectedSystems}
                        systems={systems}
                    />
                </div>
                { view !== 'rawdata' ?
                    <div className={classes.SensorFilterContainer}>
                        <SiteScoreSelector
                            selectedEquipmentRule={selectedEquipmentRule}
                            selectedEquipment={selectedEquipment}
                            setSelectedEquipmentRule={setSelectedEquipmentRule}
                            sensors={allSensors}
                        />
                    </div>
                    : 
                    <div />
                }
                { view !== 'rawdata' ?  
                    <div className={classes.GraphSelect}>
                        <GraphViewSelector chartType={chartType} setChartType={setChartTypeProps} />
                    </div>
                    : 
                    <div />
                }
                <div className={classes.TotalsContainer}>
                    <TotalsPanel
                        data={ruleScoreKpis}
                        entityType="SiteScore"
                    />
                </div>
                <div
                    className={classes.RefreshContainer}
                    aria-hidden="true"
                    role="button"
                    tabIndex={0}
                    onClick={refreshGrid}
                >
                    <span className="material-icons-outlined">refresh</span>
                </div>
                <div className={classes.ActionContainer}>
                    <BobActionMenu
                        activeTab={'SiteScore'}
                        isDisableExport={isEmpty(selectedEquipmentRule)}
                        isDownload={view === 'scoregraph'}
                        isExport={view !== 'rawdata'}
                        isExportTimeseries={false}
                        handleExport={handleExport}
                        handleExportGrid={handleExportGrid}
                        handleImageDownload={handleImageDownload}
                        handleSubscribeToArea={() => handleSubscribeToArea()}
                        view={view}
                    />
                </div>
            </div>
            { !isEmpty(selectedEquipmentTypes) || !isEmpty(selectedSystems) ?
                <ScoringGridContainer
                    aggregateType={aggregateType}
                    chartType={chartType}
                    equipmentTypes={equipmentTypes}
                    exportRawData={exportRawData}
                    healthscoreRawData={healthscoreRawData}
                    healthscoreRawDataMeta={healthscoreRawDataMeta}
                    propsFunc={propsFunc}
                    refresh={refresh}
                    refreshRawDataGrid={refreshRawDataGrid}
                    rules={rules}
                    selectedEquipmentTypes={selectedEquipmentTypes}
                    selectedSystems={selectedSystems}
                    selectedEquipment={selectedEquipment}
                    selectedEquipmentRule={selectedEquipmentRule}
                    setRefreshRawDataGrid={setRefreshRawDataGrid}
                    setSelectedEquipment={setSelectedEquipment}
                    setExportRawData={setExportRawData}
                    setRules={setRules}
                    setSelectedEquipmentRule={setSelectedEquipmentRule}
                    site={activeNavSite}
                    view={view}
                />
                :
                <InactiveScoringGridContainer />
            }
            { selectEquipmentTypeModalOpen ?
                <SelectEquipmentTypeModal
                    equipmentTypes={equipmentTypes}
                    equipmentTypesLoading={equipmentTypes.loading}
                    systems={systems}
                    systemsLoading={systemsLoading}
                    setSelectedEquipmentTypes={setSelectedEquipmentTypes}
                    setSelectedSystems={setSelectedSystems}
                    toggleSelectEquipmentTypeModalOpen={(toggle) => toggleSelectEquipmentTypeModalOpen(toggle)}
                />
                :
                null
            }
            {
                exportModalOpen ?
                    <ExportDataModal
                        entity={selectedEquipment}
                        setExportModalOpen={setExportModalOpen}
                        isExportRawData={true}
                        tabView={view}
                        selectedRuleSensors={selectedRuleSensors}
                        selectedRule={selectedEquipmentRule}
                    /> : ''
            }        
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:        state.bob.activeNavCompany,
        activeNavSite:           state.bob.activeNavSite,
        allSensors:              state.bob.allSensors,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp,
        desiredInterval:         state.dashboard.desiredInterval,
        equipmentTypes:          state.equipmentTypes,
        healthscoreRawData:      state.dashboard.healthscoreRawData,
        healthscoreRawDataMeta:  state.dashboard.healthscoreRawDataMeta,
        ruleScoreKpis:           state.dashboard.ruleScoreKpis,
        selectedRuleSensors:     state.dashboard.selectedRuleSensors,
        selectedWeatherSensors:  state.dashboard.selectedWeatherSensors,
        siteTabIndex:            state.dashboard.siteTabIndex,
        workbookModeEnabled:     state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...BobActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScoringPage));
